<template>
  <div class="searching-container">
    <div class="searching-content">
      <div class="searching-dots">
        <span class="search-dot search-dot-1" />
        <span class="search-dot search-dot-2" />
        <span class="search-dot search-dot-3" />
      </div>
      <span class="searching-text">{{ statusText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchingIndicator',

  dataStore: {
    assistantStore: 'AssistantStore'
  },

  computed: {
    statusText () {
      return this.assistantStore.Streaming.StopRequested
        ? 'Stopping response'
        : 'Thinking'
    }
  }
}
</script>

<style scoped>
.searching-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding-left: 16px;
}

.searching-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.searching-dots {
  display: flex;
  align-items: center;
  gap: 3px;
}

.search-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #9EB4EA;
  opacity: .22;
  animation: searchingPulse 1.2s infinite ease-in-out;
}

.search-dot-2 {
  animation-delay: .15s;
}

.search-dot-3 {
  animation-delay: .3s;
}

.searching-text {
  font-family: 'Inter';
  font-size: 13px;
  font-weight: 400;
  line-height: 21px;
  color: #63747D;
}

@keyframes searchingPulse {
  0%,
  80%,
  100% {
    transform: translateY(0) scale(.85);
    opacity: .22;
  }

  40% {
    transform: translateY(-4px) scale(1);
    opacity: .72;
  }
}
</style>
